export const types = {
    SET_GET_EVENTS: '[EVENTS] SET GET EVENTS',
}